import { Card } from '@/components/ui/card';
import DateRangePicker from '@/components/filters/DateRangePicker';

const TrafficPage = () => (
  <div className="space-y-6">
    <div className="flex flex-wrap items-center justify-between gap-4">
      <div>
        <h2 className="text-2xl font-semibold text-white">Traffic & Funnels</h2>
        <p className="text-sm text-slate-400">Analyze pageviews, sessions, and conversion funnels.</p>
      </div>
      <DateRangePicker />
    </div>

    <div className="grid gap-4 lg:grid-cols-2">
      <Card title="Traffic Overview">
        <p className="text-sm text-slate-400">Connect to `mv_traffic_daily` for time-series visualization.</p>
      </Card>
      <Card title="Funnel Builder">
        <p className="text-sm text-slate-400">Allow admins to select steps and see drop-off with `mv_funnel`.</p>
      </Card>
    </div>

    <Card title="Top Campaigns">
      <p className="text-sm text-slate-400">Use TanStack Table to list UTM performance.</p>
    </Card>
  </div>
);

export default TrafficPage;
